/**
 * 工作流API服务
 */
import request from '@/utils/request'

// Mock数据开关
const USE_MOCK = false

// Mock数据
const mockData = {
  statistics: {
    pending_count: 5,
    completed_count: 12,
    my_process_count: 0,
    cc_count: 3
  },
  
  pendingTasks: [
    { id: 1, process_name: '请假审批', process_title: '请假申请-张三', node_name: '部门经理审批', initiator_name: '张三', created_at: '2024-01-15 10:30:00' },
    { id: 2, process_name: '报销审批', process_title: '差旅报销-李四', node_name: '财务审批', initiator_name: '李四', created_at: '2024-01-15 09:15:00' },
    { id: 3, process_name: '采购申请', process_title: '办公用品采购', node_name: '主管审批', initiator_name: '王五', created_at: '2024-01-14 16:45:00' }
  ],
  
  completedTasks: [
    { id: 4, process_name: '请假审批', process_title: '请假申请-李四', node_name: '部门经理审批', initiator_name: '李四', completed_at: '2024-01-14 14:30:00' }
  ],
  
  ccTasks: [
    { id: 5, process_name: '采购申请', process_title: '办公用品采购', node_name: '抄送', initiator_name: '王五', created_at: '2024-01-14 16:45:00' }
  ],
  
  myProcesses: [], // 用户发起的流程
  
  processDefinitions: [
    { id: 1, process_key: 'leave_process', process_name: '请假审批', category: '人事', version: 1, status: 'published', created_at: '2024-01-01', updated_at: '2024-01-10', icon: 'Tickets' },
    { id: 2, process_key: 'expense_process', process_name: '报销审批', category: '财务', version: 2, status: 'published', created_at: '2024-01-02', updated_at: '2024-01-12', icon: 'Money' },
    { id: 3, process_key: 'purchase_process', process_name: '采购申请', category: '行政', version: 1, status: 'draft', created_at: '2024-01-10', updated_at: '2024-01-10', icon: 'ShoppingCart' }
  ],
  
  forms: [
    { id: 1, form_key: 'leave_form', form_name: '请假申请表', description: '员工请假申请', created_at: '2024-01-01', schema: { fields: [{ key: 'reason', label: '请假原因', type: 'textarea' }, { key: 'days', label: '请假天数', type: 'number' }] } },
    { id: 2, form_key: 'expense_form', form_name: '报销申请表', description: '费用报销申请', created_at: '2024-01-02', schema: { fields: [{ key: 'amount', label: '报销金额', type: 'number' }, { key: 'invoice', label: '发票', type: 'upload' }] } }
  ],
  
  users: [
    { id: 1, username: 'admin', real_name: '管理员', avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png' },
    { id: 2, username: 'zhangsan', real_name: '张三', avatar: '' },
    { id: 3, username: 'lisi', real_name: '李四', avatar: '' },
    { id: 4, username: 'wangwu', real_name: '王五', avatar: '' }
  ],
  
  roles: [
    { id: 1, role_name: '管理员', role_code: 'admin' },
    { id: 2, role_name: '部门经理', role_code: 'manager' },
    { id: 3, role_name: '普通员工', role_code: 'employee' }
  ],
  
  positions: [
    { id: 1, position_name: '总经理', position_code: 'gm' },
    { id: 2, position_name: '部门经理', position_code: 'dm' },
    { id: 3, position_name: '普通员工', position_code: 'staff' }
  ],
  
  departments: [
    { value: '1', label: '总公司', children: [
      { value: '11', label: '技术部' },
      { value: '12', label: '人事部' },
      { value: '13', label: '财务部' }
    ]}
  ]
}

// 模拟延迟
const mockDelay = (ms = 300) => new Promise(resolve => setTimeout(resolve, ms))

// 后端直接返回 { total, items }，前端组件习惯使用 { data: { total, items } }
const wrapList = res => ({ data: { total: res.total || 0, items: res.items || [] } })
const wrapData = res => ({ data: res })

export const workflowApi = {
  // ==================== 流程定义 ====================
  getProcessDefinitions(params) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        let items = mockData.processDefinitions
        
        // 按状态过滤
        if (params?.status) {
          items = items.filter(p => p.status === params.status)
        }
        
        // 按分类过滤
        if (params?.category) {
          items = items.filter(p => p.category === params.category)
        }
        
        // 按流程名称搜索
        if (params?.process_name) {
          items = items.filter(p => p.process_name.includes(params.process_name))
        }
        
        // 按流程标识搜索
        if (params?.process_key) {
          items = items.filter(p => p.process_key.includes(params.process_key))
        }
        
        return {
          data: {
            total: items.length,
            items: items
          }
        }
      })
    }
    return request.get('/workflow/process-definitions', { params }).then(wrapList)
  },
  
  // 获取流程模板（is_template=1 且已发布）
  getTemplates(params = {}) {
    return request.get('/workflow/process-definitions', {
      params: { ...params, is_template: 1, status: 'published' }
    }).then(wrapList)
  },

  // 获取当前用户可发起的已发布流程（流程中心用）
  getAccessibleProcesses(params = {}) {
    return request.get('/workflow/process-definitions', {
      params: { ...params, status: 'published', accessible: true }
    }).then(wrapList)
  },

  createProcess(data) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const newProcess = {
          id: Date.now(),
          ...data,
          version: 1,
          status: 'draft',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        }
        mockData.processDefinitions.push(newProcess)
        return { data: newProcess }
      })
    }
    return request.post('/workflow/process-definitions', data).then(wrapData)
  },
  
  getProcessDetail(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const process = mockData.processDefinitions.find(p => p.id === id)
        return { data: process || { id, process_name: '新流程', status: 'draft', nodes: [], connections: [] } }
      })
    }
    return request.get(`/workflow/process-definitions/${id}`).then(wrapData)
  },
  
  updateProcess(id, data) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const index = mockData.processDefinitions.findIndex(p => p.id === id)
        if (index > -1) {
          // 保存流程设计数据到 process_config 字段
          mockData.processDefinitions[index] = { 
            ...mockData.processDefinitions[index], 
            ...data,
            updated_at: new Date().toISOString()
          }
          // 如果有 nodes 和 connections，保存到 process_config
          if (data.nodes || data.connections) {
            mockData.processDefinitions[index].process_config = {
              nodes: data.nodes,
              connections: data.connections
            }
          }
        }
        return { data: mockData.processDefinitions[index] }
      })
    }
    return request.put(`/workflow/process-definitions/${id}`, data).then(wrapData)
  },
  
  deleteProcess(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const index = mockData.processDefinitions.findIndex(p => p.id === id)
        if (index > -1) mockData.processDefinitions.splice(index, 1)
        return { data: { success: true } }
      })
    }
    return request.delete(`/workflow/process-definitions/${id}`).then(wrapData)
  },
  
  publishProcess(id, params = {}) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const index = mockData.processDefinitions.findIndex(p => p.id === id)
        if (index > -1) {
          mockData.processDefinitions[index].status = 'published'
        }
        return { data: { success: true } }
      })
    }
    return request.post(`/workflow/process-definitions/${id}/publish`, null, { params }).then(wrapData)
  },
  
  saveProcess(id, data) {
    if (id) {
      return this.updateProcess(id, data)
    }
    return this.createProcess(data)
  },

  // M6 模板中心：与 REST 命名一致的别名方法（底层复用既有实现）
  createProcessDefinition(data) {
    return this.createProcess(data)
  },

  updateProcessDefinition(id, data) {
    return this.updateProcess(id, data)
  },

  publishProcessDefinition(id, params = {}) {
    return this.publishProcess(id, params)
  },
  
  // ==================== 流程实例 ====================
  startProcess(data) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        // 查找流程定义信息
        const processDef = mockData.processDefinitions.find(p => p.id === data.process_def_id)
        
        const newProcess = {
          id: Date.now(),
          process_def_id: data.process_def_id,
          process_name: processDef?.process_name || '未知流程',
          process_icon: processDef?.icon || 'Document',
          title: data.title,
          business_key: data.business_key,
          status: 'running',
          current_node: '待审批',
          initiator_name: '我',
          form_data: data.form_data,
          created_at: new Date().toISOString(),
          started_at: new Date().toISOString()
        }
        
        // 添加到我的流程列表
        mockData.myProcesses.unshift(newProcess)
        
        // 更新统计数据
        mockData.statistics.my_process_count = mockData.myProcesses.length
        
        return { data: newProcess }
      })
    }
    return request.post('/workflow/process-instances', data).then(wrapData)
  },
  
  // 催办流程实例
  urgeProcess(id, comment) {
    return request.post(`/workflow/process-instances/${id}/urge`, { comment }).then(wrapData)
  },

  // 抄送任务标记已读
  readCcTask(id) {
    return request.post(`/workflow/tasks/${id}/read`).then(wrapData)
  },

  // 流程监控统计
  getMonitoringStatistics() {
    return request.get('/workflow/monitoring/statistics').then(wrapData)
  },

  // 流程实例列表（管理员视角，支持状态/关键字/分页）
  requestInstances(params = {}) {
    return request.get('/workflow/process-instances', { params }).then(wrapData)
  },

  // 超时未处理任务列表
  getTimeoutTasks() {
    return request.get('/workflow/monitoring/timeout-tasks').then(wrapData)
  },

  getMyProcesses() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          total: mockData.myProcesses.length,
          items: mockData.myProcesses
        }
      }))
    }
    return request.get('/workflow/process-instances/my').then(wrapList)
  },
  
  getProcessInstance(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          id,
          process_name: '请假审批',
          title: '请假申请',
          status: 'running',
          created_at: '2024-01-15',
          tasks: []
        }
      }))
    }
    return request.get(`/workflow/process-instances/${id}`).then(wrapData)
  },
  
  cancelProcess(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { success: true } }))
    }
    return request.post(`/workflow/process-instances/${id}/cancel`).then(wrapData)
  },

  getInstanceProgress(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { instance_id: id, status: 'running', current_node_id: null, nodes: [] } }))
    }
    return request.get(`/workflow/process-instances/${id}/progress`).then(wrapData)
  },

  getInstanceLogs(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { items: [] } }))
    }
    return request.get(`/workflow/process-instances/${id}/logs`).then(wrapList)
  },

  getInstanceOperationLogs(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { items: [] } }))
    }
    return request.get(`/workflow/process-instances/${id}/operation-logs`).then(wrapList)
  },

  // M5 悬浮打印：获取实例打印数据
  getPrintData(instanceId) {
    return request.get(`/workflow/instances/${instanceId}/print-data`).then(wrapData)
  },

  // 导出流程实例打印 PDF
  exportPrintPdf(instanceId) {
    return request.get(`/workflow/instances/${instanceId}/print-pdf`, {
      responseType: 'blob'
    })
  },

  // 上传 Word/Excel/PDF 套打模板底版
  uploadPrintBackground(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/print-templates/upload-background', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => ({ data: res.data }))
  },

  // ==================== 任务 ====================
  getPendingTasks() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          total: mockData.pendingTasks.length,
          items: mockData.pendingTasks
        }
      }))
    }
    return request.get('/workflow/tasks/pending').then(wrapList)
  },
  
  getCompletedTasks() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          total: 2,
          items: [
            { id: 4, process_name: '请假审批', process_title: '请假申请-李四', node_name: '部门经理审批', initiator_name: '李四', completed_at: '2024-01-14' }
          ]
        }
      }))
    }
    return request.get('/workflow/tasks/completed').then(wrapList)
  },
  
  getCcTasks() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          total: 1,
          items: [
            { id: 5, process_name: '采购申请', process_title: '办公用品采购', node_name: '抄送', initiator_name: '王五', created_at: '2024-01-14' }
          ]
        }
      }))
    }
    return request.get('/workflow/tasks/cc').then(wrapList)
  },
  
  getTaskDetail(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const task = mockData.pendingTasks.find(t => t.id === id) || mockData.completedTasks[0]
        return { data: task || { id, process_name: '请假审批', process_title: '请假申请', node_name: '部门经理审批', initiator_name: '张三' } }
      })
    }
    return request.get(`/workflow/tasks/${id}`).then(wrapData)
  },

  completeTask(id, data) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { success: true } }))
    }
    return request.post(`/workflow/tasks/${id}/complete`, data).then(wrapData)
  },

  reviseTask(id, data) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { success: true } }))
    }
    return request.post(`/workflow/tasks/${id}/revise`, data).then(wrapData)
  },
  
  transferTask(id, toUserId, reason) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: { success: true } }))
    }
    return request.post(`/workflow/tasks/${id}/transfer`, null, {
      params: { to_user_id: toUserId, reason }
    }).then(wrapData)
  },
  
  // ==================== 表单定义 ====================
  getForms(params) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        let items = mockData.forms
        
        // 按表单名称搜索
        if (params?.form_name) {
          items = items.filter(f => f.form_name.includes(params.form_name))
        }
        
        // 按表单标识搜索
        if (params?.form_key) {
          items = items.filter(f => f.form_key.includes(params.form_key))
        }
        
        return {
          data: {
            total: items.length,
            items: items
          }
        }
      })
    }
    return request.get('/workflow/forms', { params }).then(wrapList)
  },
  
  createForm(data) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const newForm = {
          id: Date.now(),
          ...data,
          created_at: new Date().toISOString()
        }
        mockData.forms.push(newForm)
        return { data: newForm }
      })
    }
    return request.post('/workflow/forms', data).then(wrapData)
  },
  
  getFormDetail(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const form = mockData.forms.find(f => f.id === id)
        return { data: form || { id, form_name: '新表单', form_key: `form_${id}`, schema: { fields: [], config: {} } } }
      })
    }
    return request.get(`/workflow/forms/${id}`).then(wrapData)
  },

  getFieldPermissions(processDefId, nodeId) {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: {
          items: []
        }
      }))
    }
    return request.get(`/workflow/process-definitions/${processDefId}/field-permissions`, {
      params: { node_id: nodeId }
    }).then(wrapList)
  },
  
  updateForm(id, data) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const index = mockData.forms.findIndex(f => f.id === id)
        if (index > -1) {
          mockData.forms[index] = { ...mockData.forms[index], ...data }
        }
        return { data: mockData.forms[index] }
      })
    }
    return request.put(`/workflow/forms/${id}`, data).then(wrapData)
  },
  
  deleteForm(id) {
    if (USE_MOCK) {
      return mockDelay().then(() => {
        const index = mockData.forms.findIndex(f => f.id === id)
        if (index > -1) mockData.forms.splice(index, 1)
        return { data: { success: true } }
      })
    }
    return request.delete(`/workflow/forms/${id}`).then(wrapData)
  },
  
  saveForm(id, data) {
    if (id) {
      return this.updateForm(id, data)
    }
    return this.createForm(data)
  },
  
  // ==================== 统计数据 ====================
  getStatistics() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({ data: mockData.statistics }))
    }
    return request.get('/workflow/statistics').then(wrapData)
  },
  
  // ==================== 基础数据 ====================
  getUsers() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: { items: mockData.users }
      }))
    }
    return request.get('/system-management/users')
  },
  
  getRoles() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: { items: mockData.roles }
      }))
    }
    return request.get('/system-management/roles')
  },
  
  getPositions() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: { items: mockData.positions }
      }))
    }
    return request.get('/system-management/positions')
  },
  
  getDepartments() {
    if (USE_MOCK) {
      return mockDelay().then(() => ({
        data: { items: mockData.departments }
      }))
    }
    return request.get('/system-management/departments/tree')
  },

  // ==================== 业务模块 ====================

  publishBusinessModule(processDefId, data) {
    return request.post(`/workflow/process-definitions/${processDefId}/publish-module`, data).then(wrapData)
  },

  getBusinessModules() {
    return request.get('/workflow/business-modules').then(wrapList)
  },

  getBusinessModule(moduleKey) {
    return request.get(`/workflow/business-modules/${moduleKey}`).then(wrapData)
  },

  getBusinessModuleInstances(moduleKey, params = {}) {
    return request.get(`/workflow/business-modules/${moduleKey}/instances`, { params }).then(wrapData)
  },

  unpublishBusinessModule(moduleKey) {
    return request.delete(`/workflow/business-modules/${moduleKey}`).then(wrapData)
  }
}
